const Timer = ({ handleHubChange }) => {
  return (
    <button
      className='bg-secondary rounded-xl p-4'
      onClick={() => handleHubChange('TIMER')}
    >
      <div className='flex items-center gap-4 mb-4'>
        <h2 className='text-lg font-semibold'>Timer</h2>
      </div>
      <p className='text-sm text-gray-400 mb-4 text-left'>
        Use the timer your coach recommends
      </p>
    </button>
  );
};

export default Timer;
